import React from "react";
import { Box, styled } from "@mui/material";
import logoNBX from "../../../images/neubox-logo.png";

const SectionLogo = () => {
  const Image = styled("img")(({ theme }) => ({
    objectFit: "scale-down",
    width: "150px",
    margin: "2rem auto",
    [theme.breakpoints.up('sm')]: {
      width: "195px",
    },
  }));

  return (
    <Box sx={{ display: "flex" }}>
      <Image src={logoNBX} alt="logo neubox" />
    </Box>
  );
};

export default SectionLogo;
